<template>
    <div v-click-outside="close" class="space-y-4">
        <label
            v-if="$slots.default"
            :for="'select-dropdown-' + key"
            class="text-body-sm font-semibold text-black"
        >
            <slot></slot>
        </label>

        <div class="inline-block relative group w-full select-none">
            <div
                class="flex justify-between items-center border rounded w-full py-12 px-16 hover:cursor-pointer min-h-44"
                :class="[error ? 'border-semantic-error' : 'border-primary-80']"
                @click="toggleDropdown"
            >
                <loading v-if="loading" class="pl-16 mr-auto" size="small"></loading>
                <span v-else class="text-black font-normal">{{ label }}</span>
                <svg-icon
                    :class="[isOpen ? 'rotate-180' : '']"
                    type="keyboard-arrow-down"
                />
            </div>
            <div v-if="isOpen">
                <multi-level-dropdown-child :options="newArray" @selected-item="handleSelectedItem" />
            </div>
        </div>

        <p v-if="error" class="text-semantic-error text-body-sm">{{ capitaliseFirst(error) }}</p>
    </div>
</template>

<script>
import MultiLevelDropdownChild from "./MultiLevelDropdownChild.vue";
import SvgIcon from "../../components/ui/SvgIcon";
import clickOutside from '../../mixins/clickOutside';
import uniqueId from "lodash/uniqueId";
import Loading from '../ui/Loading.vue';
import {ucfirst} from "../../../shared/helpers";

export default {
    name: "MultiLevelDropdown",
    components: {MultiLevelDropdownChild, SvgIcon, 'loading': Loading},
    mixins: [clickOutside],
    props: {
        value: {
            type: [String, Number, Array]
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        errors: Array
    },
    data() {
        return {
            key: uniqueId('option'),
            newArray: [],
            selectedItem: null,
            isOpen: false,
            loading: false,
        }
    },
    computed: {
        label() {
            if (this.selectedItem) {
                return this.selectedItem.label;
            } else {
                return this.$t('form.dropdown.placeholder').toString();
            }
        },
        error() {
            if (!this.errors) {
                return null;
            }

            return Array.isArray(this.errors) ? this.errors[0] : this.errors;
        },
    },
    methods: {
        capitaliseFirst(text = '') {
            return ucfirst(text);
        },
        close() {
            this.isOpen = false;
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
            if (this.isOpen && this.options.length === 0) {
                this.loadOptions()
            }
        },
        formatOptions(options, parent = null) {
            if (!options) return;
            options.filter(x => !parent ? !x.parent : x.parent === parent)
                .forEach(item => {
                    item.children = this.options.filter(y => y.parent === item.key);

                    if (!item.parent) {
                        this.newArray.push(item);
                    }

                    if (item.children.length > 0) {
                        this.formatOptions(item.children, item.key);
                    }
                });
        },
        handleSelectedItem(option) {
            this.selectedItem = option;
            this.isOpen = false;
            this.$emit('input', option.key);
        },
        loadOptions() {
            this.loading = true
            this.$emit('load')
        },
        reload() {
            this.formatOptions(this.options)
            this.selectedItem = this.options.find(x => x.key === this.value)
            this.loading = false
        }
    },
    beforeMount() {
        if (this.value && this.options.length === 0) {
            this.loadOptions()
        } else {
            this.formatOptions(this.options);
            this.selectedItem = this.options.find(x => x.key === this.value)
        }
    },
}
</script>
